import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IStateList, State } from '../models/state';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root'})
export class StateService extends BaseRestService<State, IStateList> implements OnDestroy{

  constructor(http: HttpClient, protected router: Router) {
    super(StateService, http, 'api/states', 'state', router);

    // enable caching
    this.cacheEnabled = true;
  }

  ngOnDestroy(): void {}

  public getName(id: number): string {
    const item = this.getCache().find((i) => id === i.id );
    if (item != null) {
      return item.name;
    }
    else {
      return id.toString();
    }
  }
}
